import { create } from 'zustand';

type State = {
  succesCreateAccount: boolean;
  clientID: string | null;
  sucessActivateAccount: boolean;
  sso_token: string | null;
};
type Actions = {
  setSuccesCreateAccount: () => void;
  setClientID: (newClientID: string) => void;
  setSuccesActivateAccount: () => void;
  setSSOToken: (token: string) => void;
};

const initialState: State = {
  succesCreateAccount: false,
  sucessActivateAccount: false,
  clientID: null,
  sso_token: null
};

export const useSignUpStore = create<State & Actions>()((set) => ({
  ...initialState,
  setSuccesCreateAccount: () => {
    set({ succesCreateAccount: true });
  },
  setSuccesActivateAccount: () => {
    set({ sucessActivateAccount: true });
  },
  setClientID: (newClientID) => {
    set({ clientID: newClientID });
  },
  setSSOToken: (token) => {
    set({ sso_token: token });
  }
}));
